var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepper-item",class:{
    'stepper-item--active': _vm.selected == _vm.$vnode.key,
    'stepper-item--disabled': _vm.disabled,
  },on:{"click":_vm.activate}},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text--small mt-1 grey--text"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }